import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getInpcUrl = (cId) => `/companies/${cId}/inpc`;
const getInpcByIdUrl = (iId, cId) => `/companies/${cId}/inpc/${iId}`;
const addInpcUrl = (cId) => `/companies/${cId}/inpc`;
const updateInpcUrl = (iId, cId) => `/companies/${cId}/inpc/${iId}`;

const service = {
  configure(endpoint, auth, defaultHeaders) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, filters, limit, page, orderBy, order) {
    const url = getInpcUrl(companyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(inpcId, companyId) {
    const url = getInpcByIdUrl(inpcId, companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, inpc) {
    const url = addInpcUrl(companyId);
    return this.axios
      .post(url, inpc, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(inpcId, companyId, inpc) {
    const url = updateInpcUrl(inpcId, companyId);
    return this.axios
      .put(url, inpc, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/inpc.api.js